import $ from 'jquery'

import colors from '../../../lib/colors'

import { roll, pos, prev, rew, play, stop, fwd, next, insert, download, loop} from './buttons/buttons'

export default function(o){

  var set = function(roll){
    if(!roll){
      c.roll.set('ERROR')
      c.play.hide()
      c.stop.hide()
      c.insert.hide()
      c.download.hide()
    } else {
      c.roll.set(roll)
      c.insert.show()
      c.insert.css({
        
      })
      c.download.show()
      c.loop.show()
      if(o.playing){
        c.stop.show()
      } else {
        c.play.show()
      }
    }
  }


  var setSequence = function(sequence){

    var lang = o.store('lang')
    var tag = sequence[lang]

    c.roll.setSequence(tag)

    c.insert.hide()

    c.download.show()
    c.download.css({right: 0})

    c.loop.hide()

    if(o.playing){
      c.stop.show()
    } else {
      c.play.show()
    }

  }

  var c = {}

  var rollDiv = c.roll = roll(o,c)
  var posDiv = c.pos = pos(o,c)

  var playDiv = c.play = play(o,c).hide()
  var stopDiv = c.stop = stop(o,c).hide()

  var prevDiv = c.prev = prev(o,c).hide()
  var rewDiv = c.rew = rew(o,c).hide()
  var fwdDiv = c.fwd = fwd(o,c).hide()
  var nextDiv = c.next = next(o,c).hide()

  var loopDiv = c.loop = loop(o,c).hide()

  var insertDiv = c.insert = insert(o,c).hide()
  var downloadDiv = c.download = download(o,c).hide()

  var div =
    $('<div>')
    .css({
      position: 'fixed',
      overflow: 'hidden',
      whiteSpace: 'nowrap',
      width: '400px',
      height: '34px',
      paddingRight: '34px',
      top: '368px',
      left: 0,
      borderBottom: '1px solid '+colors.grey.s_800,
    })
    .append([
      rollDiv,
      posDiv,
      prevDiv,
      rewDiv,
      playDiv,
      stopDiv,
      fwdDiv,
      nextDiv,
      insertDiv,
      downloadDiv,
      loopDiv,
    ]);

  div.roll = rollDiv
  div.pos = posDiv
  div.prev = prevDiv
  div.rew = rewDiv
  div.play = playDiv
  div.stop = stopDiv
  div.fwd = fwdDiv
  div.next = nextDiv
  div.insert = insertDiv
  div.download = downloadDiv
  div.loop = loopDiv

  div.set = set
  div.setSequence = setSequence

  return div

}



// WEBPACK FOOTER //
// ./src/client/view/admin/controls/controls.js